module.exports = __webpack_public_path__ + "static/media/2.928a2038.wav";